import React, { useEffect, useState } from 'react';
import api from './api';
import Swal from 'sweetalert2';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 800px;
  margin: 10px auto;
  padding: 15px;
  font-family: 'Inter', sans-serif;
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 20px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0,0,0,0.05);
  th, td { padding: 12px; text-align: left; border-bottom: 1px solid #eee; }
  th { background: #f8f9fa; font-weight: 600; }
`;

function Periodos() {
  const [periodos, setPeriodos] = useState([]);

  useEffect(() => {
    fetchPeriodos();
  }, []);

  const fetchPeriodos = async () => {
    try {
      const res = await api.get('/periodos');
      setPeriodos(res.data);
    } catch (err) { Swal.fire('Error', 'No se pudo cargar periodos', 'error'); }
  };

  const handlePeriodo = async (p = null) => {
    const isEdit = !!p;
    const { value: formValues } = await Swal.fire({
      title: isEdit ? 'Editar Periodo' : 'Nuevo Periodo',
      html:
        `<input id="swal-detalle" class="swal2-input" placeholder="Detalle (ej. 08:00 - 12:00)" value="${p?.per_detalle || ''}">` +
        `<input id="swal-entrada" type="time" class="swal2-input" placeholder="Hora Entrada" value="${p?.per_hora_entrada || ''}">` +
        `<input id="swal-salida" type="time" class="swal2-input" placeholder="Hora Salida" value="${p?.per_hora_salida || ''}">`,
      focusConfirm: false,
      showCancelButton: true,
      preConfirm: () => ({
        per_detalle: document.getElementById('swal-detalle').value,
        per_hora_entrada: document.getElementById('swal-entrada').value,
        per_hora_salida: document.getElementById('swal-salida').value
      })
    });

    if (formValues) {
      try {
        if (isEdit) await api.put(`/periodos/${p.per_id}`, formValues);
        else await api.post('/periodos', formValues);
        Swal.fire('Éxito', 'Guardado', 'success');
        fetchPeriodos();
      } catch (err) { Swal.fire('Error', 'No se pudo guardar', 'error'); }
    }
  };

  const deletePeriodo = async (id) => {
    const result = await Swal.fire({
      title: '¿Eliminar periodo?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'Eliminar'
    });
    if (result.isConfirmed) {
      try {
        await api.delete(`/periodos/${id}`);
        fetchPeriodos();
      } catch (err) { Swal.fire('Error', 'No se pudo eliminar', 'error'); }
    }
  };

  return (
    <Container>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
        <Title>🕒 Gestión de Periodos</Title>
        <button 
          onClick={() => handlePeriodo()}
          style={{ background: '#1976d2', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer' }}
        >
          + Nuevo Periodo
        </button>
      </div>
      <Table>
        <thead>
          <tr>
            <th>Detalle</th>
            <th>Entrada</th>
            <th>Salida</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {periodos.map(p => (
            <tr key={p.per_id}>
              <td>{p.per_detalle}</td>
              <td>{p.per_hora_entrada}</td>
              <td>{p.per_hora_salida}</td>
              <td>
                <button onClick={() => handlePeriodo(p)} style={{ marginRight: '5px' }}>✏️</button>
                <button onClick={() => deletePeriodo(p.per_id)} style={{ color: '#d32f2f' }}>🗑️</button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
}

export default Periodos;
